/**
 * customer-manager-model.js
 * 概述:
 * 客户管理服务API
 *
 * API:
 * 1.创建客户接口   createCustomer
 * 2.修改客户       updateCustomer
 * 3.查询客户       queryCustomer
 * @author Qiutm 2018/4/13
 */
import axios from 'axios'
import setConfig from '@/config/axios-config'
import { saveAs } from 'file-saver'
setConfig(axios)

const basePath = '/BaseInfoWeb/action/baseinfo'
const actionPath = '/BaseInfoWeb/action'
const axiosConfig = {
  headers: {
    'Content-Type': 'application/x-www-form-urlencoded'
  }
}
/**
 * 创建客户
 * @param  {object} param
 * @return {object}  promise
 */
const createCustomer = (param) => {
  return axios({ method: 'POST', url: basePath + '/createCustomer', data: param })
    .then(res => res.data)
}

/**
 * 修改客户
 * @param  {object} param
 * @return {object}  promise
 */
const updateCustomer = (param) => {
  return axios({ method: 'POST', url: basePath + '/updateCustomer', data: param })
    .then(res => res.data)
}

/**
 * 删除客户服务资源项
 * @param  {object} param
 * @return {object}  promise
 */
const delCustomerServiceItem = (id) => {
  return axios({ method: 'DELETE', url: actionPath + '/fareInfo/deleteFare?id=' + id })
    .then(res => res.data)
}
/**
 * 删除客户开通资料
 * @param  {object} param
 * @return {object}  promise
 */
const delCustomerFile = (id) => {
  return axios({ method: 'DELETE', url: basePath + '/deleteFile?id=' + id })
    .then(res => res.data)
}

// 查询客户接口
// param: {organizationId: "1525835962859", excludeSchool: true}
// excludeSchool: true(不包含学校), false(包含学校)
const queryCustomer = (param) => {
  return axios({ method: 'POST', url: basePath + '/getOrganizationInfo', data: param })
    .then(res => res.data)
}

// 查询机构列表
const getOrganizationList = (param) => {
  return axios({ method: 'POST', url: basePath + '/listOrganizations', data: param })
    .then(res => res.data)
}

const getCustomerList = (data = {}) => {
  return axios({ method: 'POST', url: basePath + '/listOrganizations', data: data })
    .then(res => res.data)
}

// param: {organizationId: "1525835962859", excludeSchool: true}
// excludeSchool: true(不包含学校), false(包含学校)
const getCustomerInfo = (data = {}) => {
  return axios({ method: 'POST', url: basePath + '/getOrganizationInfo', data: data })
    .then(res => res.data)
}

const getBelowCustomerInfo = (data = {}) => {
  return axios.get(`${actionPath}/agentTree`, {params: data}).then(res => res.data)
}

/**
 * 导入客户
 * @author wangk 2018-04-18T20:07:00+0800
 * @param  {Object} params { orgId: '', formData: [file] }
 * @return {Promise}
 */
const importCustomer = (params = {}) => {
  return axios.post(basePath + `/import/organization/${params.orgId}/${params.operationUserId}`, params.formData)
    .then(res => res.data)
}

/**
 * 导出客户
 * @author wangk 2018-04-18T20:11:50+0800
 * @param  {Object} params { data: { orgId: '', exportType: '1' } }
 *                         exportType: 1(直属下级), 2(所有下级)
 * @return {Promise}
 */
const exportCustomer = (params = {}) => {
  return axios.post(basePath + '/export/organization', params)
    .then(res => res.data)
}

const deleteCustomer = (data = {}) => {
  return axios({ method: 'POST', url: basePath + '/deleteCustomer ', data: data })
    .then(res => res.data)
}

const sendMobileMessge = (data = {}) => {
  return axios({ method: 'POST', url: basePath + '/sendVertificationCode ', data: data })
    .then(res => res.data)
}

/***
 * sendMobileMessgeUnAuthorize
 * 发送短信验证码，不带token验证
 * data: { mobilephone: ''}
 */
const sendMobileMessgeUnAuthorize = (data = {}) => {
  let axiosConfigs = {
    unAuth: 1
  }
  return axios.post(`${basePath}/sendVertificationCode`, data, axiosConfigs)
    .then(res => res.data)
}

/***
 * checkVertificationCode
 * 验证短信验证码，不带token验证
 */
const checkVertificationCodeUnAuthorize = (data = {}) => {
  let axiosConfigs = {
    unAuth: 1
  }
  return axios.post(`${basePath}/checkVertificationCode`, data, axiosConfigs)
    .then(res => res.data)
}

/**
 * 教育局管理员查看机构下直属学校
 * @author wangk 2018-05-25T14:17:35+0800
 * @param  {Object} params { organizationId: '' }
 * @return {[type]}        [description]
 */
const listOrganizationDirectSchools = (params = {}) => {
  return axios.post(basePath + '/listOrganizationDirectSchools', params)
    .then(res => res.data)
}

/**
 * 修改信息管理员密码
 * @author wangk 2018-11-21T10:20:17+0800
 * @param  {Object} params { name: '张三', mobilePhone: '', roleName: '' }
 * @return {[type]}        [description]
 */
const resetInformationManagerPwd = (params = {}) => {
  return axios.post(`${basePath}/resetPassword`, params).then(res => res.data)
}

/**
 * 判断学校是否初始化
 * @author changh 2018-11-21T10:20:17+0800
 * @param  {Object} params {orgid: xxxxx}
 * @return {[type]}        [description]
 */
const isSchoolInitialized = (params = {}) => {
  let param = 'app=isSchoolInitialized&json=' + JSON.stringify(params) + '&time=' + Math.random()
  return axios.post(`${basePath}/schoolInfo/isSchoolInitialized`, param, axiosConfig)
    .then(res => res.data)
}

/**
 * 学校初始化
 * @author changh 2018-11-21T10:20:17+0800
 * @param  {Object} params { name: '张三', mobilePhone: '', roleName: '' }
 * @return {[type]}        [description]
 */
const initSchoolBaseInfo = (params = {}) => {
  let param = 'app=schoolBaseInfo&flag=init&json=' + JSON.stringify(params) + '&time=' + Math.random()
  return axios.post(`${basePath}/schoolBaseInfo`, param, axiosConfig)
    .then(res => res.data)
}

/**
 * 判断学校学生是否需要整体升年级
 * @author changh 2018-11-21T10:20:17+0800
 * @param  {Object} params {orgid: xxxxx}
 * @return {[type]}        [description]
 */
const isNeedUpgrade = (params = {}) => {
  let param = 'app=schoolInfo&flag=isNeedUpgrade&json=' + JSON.stringify(params) + '&time=' + Math.random()
  return axios.post(`${basePath}/schoolInfo`, param, axiosConfig)
    .then(res => res.data)
}

/**
 * 学生整体升年级
 * @author changh 2018-11-21T10:20:17+0800
 * @param  {Object} params { name: '张三', mobilePhone: '', roleName: '' }
 * @return {[type]}        [description]
 */
const studentUpgrade = (params = {}) => {
  let param = 'app=studentUpgrade&json=' + JSON.stringify(params) + '&time=' + Math.random()
  return axios.post(`${basePath}/schoolInfo/upgrade`, param, axiosConfig)
    .then(res => res.data)
}

/**
 * 导入用户头像
 * @author qiutm 2018-12-13 15:15:55
 * @param  {Object} params {,
 *                           file: [二进制流文件]
 *                         }
 * @return promise
 */
const uploadOssFile = (params) => {
  return axios({ method: 'POST', url: `${basePath}/uploadOssFile`, data: params.file })
    .then(res => res.data)
}

/**
 * 财务对账列表
 * @author chenxb 2022-08-02 17:15:55
 * @param  {Object} params
 * @return promise
 */
const getFinanceList = (data = {}) => {
  return axios({ method: 'POST', url: actionPath + '/fareInfo/listOrg', data: data })
    .then(res => res.data)
}
/**
 * 查询财务对账详情
 * @author chenxb 2022-08-02 17:15:55
 * @param  {Object} params
 * @return promise
 */
const getFinanceDetial = (id) => {
  return axios({ method: 'GET', url: actionPath + '/fareInfo/orgFareDetail?orgId=' + id })
    .then(res => res.data)
}

/**
 * 下载开通资料
 * @author chenxb 2022-08-02 17:15:55
 * @param  {Object} params
 * @return promise
 */
const downLoadFareFiles = (id) => {
  return axios({
    method: 'get',
    url: actionPath + '/fareInfo/downLoadFareFiles?fareId=' + id,
    responseType: 'blob'
  }).then(async (res) => {
    if (res.data.size !== 0) {
      const blob = new Blob([res.data])
      saveAs(blob, '开通资料.zip')
    }
  })
}

export {
  createCustomer,
  updateCustomer,
  delCustomerServiceItem,
  delCustomerFile,
  queryCustomer,
  getCustomerList,
  getOrganizationList,
  importCustomer,
  exportCustomer,
  getCustomerInfo,
  getBelowCustomerInfo,
  deleteCustomer,
  sendMobileMessge,
  sendMobileMessgeUnAuthorize,
  checkVertificationCodeUnAuthorize,
  listOrganizationDirectSchools,
  resetInformationManagerPwd,
  isSchoolInitialized,
  initSchoolBaseInfo,
  isNeedUpgrade,
  studentUpgrade,
  uploadOssFile,
  getFinanceList,
  getFinanceDetial,
  downLoadFareFiles
}



// WEBPACK FOOTER //
// ./src/model/customer-manager-model.js